// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var ctaLine = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.justifySelf("flexEnd"),
      BsCssJs$PrezzeeRibbon.flexGrow(1),
      BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.nthChild({
                  NAME: "add",
                  VAL: [
                    1,
                    2
                  ]
                }, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(20)))])])
    ]);

var hAlignCenter = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.justifyContent("center")]);

var Styles = {
  ctaLine: ctaLine,
  hAlignCenter: hAlignCenter
};

function SmallHeroTile__CtaLine(props) {
  var hAlign = props.hAlign;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var hAlign$1 = hAlign !== undefined ? hAlign : /* Default */0;
  var hAlignCss = hAlign$1 >= 2 ? hAlignCenter : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    className$1,
                    hAlignCss,
                    ctaLine
                  ])
            });
}

var make = SmallHeroTile__CtaLine;

export {
  Styles ,
  make ,
}
/* ctaLine Not a pure module */
